import Vue from 'vue'
import Storage from 'vue-ls';

const storageOptions = {
	namespace: 'smart__', // key prefix
	name: 'storage', // name variable Vue.[ls] or this.[$ls],
	storage: 'session', // storage name session, local, memory
};

const DEVICE_LIST_KEY = 'DEVICE_LIST';
const USER_TOKEN_KEY = 'USER_TOKEN';
const TOKEN_RENEWAL_KEY = 'RENEWAL_TOKEN';
const LAST_ROUTE_KEY = 'LAST_ROUTE';
const AUTH_TOKEN_EXP = 3600 * 1000;
const DEVICE_LIST_EXP = 3600 * 1000;
const USER_TOKEN_EXP = 3600 * 1000;
const TOKEN_RENEWAL_EXP = 8 * 3600 * 1000; //8 hours
const LAST_ROUTE_EXP = 48 * 3600 * 1000; //8 hours

Vue.use(Storage, storageOptions);


export function setDeviceList(data) {
    Vue.storage.set(DEVICE_LIST_KEY, JSON.stringify(data), DEVICE_LIST_EXP);
}

export function getDeviceList() {
    try {
        return JSON.parse(Vue.storage.get(DEVICE_LIST_KEY, ""));
    } catch (err) {
        return "";
    }
}

export function clearDeviceList() {
    Vue.storage.remove(DEVICE_LIST_KEY);
}


export function setUserToken(data) {
    Vue.storage.set(USER_TOKEN_KEY, data, USER_TOKEN_EXP);
}

export function getUserToken() {
    try {
        return Vue.storage.get(USER_TOKEN_KEY, "");
    } catch (err) {
        return "";
    }
}

export function clearUserToken() {
    Vue.storage.remove(USER_TOKEN_KEY);
}


export function getSelectedDeviceToken(mac) {
    try {
        const list = JSON.parse(Vue.storage.get(DEVICE_LIST_KEY, null));
        return list.find(x => x.mac === mac).token;
    } catch (err) {
        return null;
    }
}


export function setTokenRenewal(data) {
    Vue.storage.set(TOKEN_RENEWAL_KEY, JSON.stringify(data), TOKEN_RENEWAL_EXP);
}

export function getTokenRenewal() {
    try {
        return JSON.parse(Vue.storage.get(TOKEN_RENEWAL_KEY, ""));
    } catch (err) {
        return "";
    }
}

export function clearTokenRenewal() {
    Vue.storage.remove(TOKEN_RENEWAL_KEY);
}


export function setLastRoute(data) {
    Vue.storage.set(LAST_ROUTE_KEY, JSON.stringify(data), LAST_ROUTE_EXP);
}

export function getLastRoute() {
    try {
        return JSON.parse(Vue.storage.get(LAST_ROUTE_KEY, ""));
    } catch (err) {
        return "";
    }
}

export function clearLastRoute() {
    Vue.storage.remove(LAST_ROUTE_KEY);
}